import React from "react";
import "./EngineSwitch.scss";

const EngineSwitch: React.FC = () => {
  return (
    <div className="EngineSwitch">
      <div className="toggle-button-cover">
        <div id="button-3" className="engine-button r">
          <input className="engine-checkbox" type="checkbox" />
          <div className="knobs"></div>
          <div className="layer"></div>
        </div>
      </div>
    </div>
  );
};

export default EngineSwitch;
